import { Flex, Text, useTheme } from '@chakra-ui/react';
import { useToken } from '@chakra-ui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FA_ICONS } from '../../icons';

type QualificationFactPillProps = {
  icon: string;
  text: string;
};

export const QualificationFactPill: React.FC<QualificationFactPillProps> = (props) => {
  const { icon, text } = props;
  const theme = useTheme();
  if (!icon || !text) return <></>;
  return (
    <Flex
      padding="4px 8px"
      border="1px solid"
      borderColor="scheme.borderTertiary"
      borderRadius="8px"
      align="center"
      mr="8px"
      mt="8px"
    >
      <FontAwesomeIcon
        icon={FA_ICONS[icon as keyof typeof FA_ICONS]}
        width="15px"
        style={{ margin: '0 4px', color: theme.colors.scheme.contentTertiary, maxHeight: '15px' }}
      />
      <Text variant="label-small" color="scheme.contentSecondary" ml="4px" mb="-2px">
        {text}
      </Text>
    </Flex>
  );
};
